import produce from 'immer';
import { getItemInList } from '../utils/lists_helper';
import { addToList, removeFromList } from '../../../utils/requests/list_requests';

// reducer name
export const LISTS = 'lists';

export const ADD_ITEM_TO_LIST = 'ADD_ITEM_TO_LIST';
export const REMOVE_ITEM_FROM_LIST = 'REMOVE_ITEM_FROM_LIST';
export const ADD_CREATED_LIST = 'ADD_CREATED_LIST';

const addItemToList = ({ id, objectId, listId, type, order }) => {
  return { type: ADD_ITEM_TO_LIST, payload: { id, listId, type, objectId, order } };
};

const removeItemFromList = ({ listId, type, objectId }) => {
  return { type: REMOVE_ITEM_FROM_LIST, payload: { objectId, listId, type } };
};

export const addListItem = (userId, listId, type, objectId) => {
  return dispatch => {
    return addToList(listId, type, objectId, userId)
      .then(addedListItem => {
        dispatch(addItemToList(addedListItem));
      })
      .catch(err => {
        console.error('THUNK ACTION addListItem error', err);
      });
  };
};

export const removeFromListItem = (userId, itemId, listId) => {
  return dispatch => {
    return removeFromList(listId, itemId, userId)
      .then(removedListItem => {
        dispatch(removeItemFromList(removedListItem));
      })
      .catch(err => {
        console.error('THUNK ACTION removeFromListItem error', err);
      });
  };
};

export const toggleListItem = (listId, type, objectId) => {
  return (dispatch, getState) => {
    const {
      lists: { listItems },
      context: { currentUser }
    } = getState();

    const item = getItemInList(type, objectId, listItems[listId]);
    return item ? dispatch(removeFromListItem(currentUser.id, item.id, listId)) : dispatch(addListItem(currentUser.id, listId, type, objectId, item));
  };
};

export const addCreatedList = ({ list_id, order, title }) => {
  return { type: ADD_CREATED_LIST, payload: { id: list_id, order, title } };
};

export const initialListState = {
  listItems: {},
  lists: []
};

// disabled default case because Immer automatically returns a default case
/* eslint-disable default-case, no-unused-expressions */
const handleAddToListExistingType = (draftState, { listId, type, objectId, id, order }) => {
  draftState.listItems[listId][type][objectId] = {
    id,
    order
  };
};

const handleAddToListNewType = (draftState, { listId, type, id, order, objectId }) => {
  draftState.listItems[listId] = {
    [type]: {
      [objectId]: {
        id,
        order
      }
    }
  };
};

const handleRemoveFromList = (draftState, { listId, objectId, type }) => {
  const list = draftState.listItems[listId];
  delete list[type][objectId];

  if (Object.keys(list[type]).length === 0) {
    delete list[type];
  }
};

const lists = produce((draftState, action) => {
  switch (action.type) {
    case ADD_ITEM_TO_LIST:
      Object.prototype.hasOwnProperty.call(draftState.listItems[action.payload.listId], action.payload.type)
        ? handleAddToListExistingType(draftState, action.payload)
        : handleAddToListNewType(draftState, action.payload);
      break;
    case REMOVE_ITEM_FROM_LIST:
      handleRemoveFromList(draftState, action.payload);
      break;
    case ADD_CREATED_LIST:
      draftState.lists.push({ id: action.payload.id, order: action.payload.order, title: action.payload.title });
      draftState.listItems[action.payload.id] = {};
      break;
  }
}, initialListState);

export default lists;
